import { Box } from '@zillow/constellation-10';
import { Bone } from '@zg-rentals/satellite-components';
import SkeletonContainer from '../../../SkeletonContainer';

/** Skeleton placeholder for form field (label + control). */
const FormFieldSkeleton = () => (
  <Box css={{ display: 'flex', flexDirection: 'column', gap: 'xs', marginBottom: 'default' }}>
    <Bone type="line" css={{ width: '40%', height: '350' }} />
    <Bone type="line" css={{ width: '100%', height: '1000' }} />
  </Box>
);

/** Skeleton for the financial expectations and pet policy sections while criteria are loading. */
export default function RenterScreeningCriteriaModalSkeleton() {
  return (
    <SkeletonContainer>
      <Box css={{ display: 'flex', flexDirection: 'column', gap: 'default' }}>
        <Box>
          <Box css={{ marginBottom: 'tight' }}>
            <Bone type="line" css={{ width: '70%', height: '500' }} />
          </Box>
          <Bone type="line" css={{ width: '100%', marginBottom: 'default' }} />
          <Bone type="line" css={{ width: '90%', marginBottom: 'default' }} />
          <FormFieldSkeleton />
          <Box css={{ display: 'flex', alignItems: 'center', gap: 'tight', marginBottom: 'default' }}>
            <Bone type="line" css={{ width: '600', height: '600' }} />
            <Bone type="line" css={{ width: '55%', height: '350' }} />
          </Box>
          <FormFieldSkeleton />
          <FormFieldSkeleton />
          <Box css={{ display: 'flex', alignItems: 'center', gap: 'tight', marginBottom: 'default' }}>
            <Bone type="line" css={{ width: '600', height: '600' }} />
            <Bone type="line" css={{ width: '45%', height: '350' }} />
          </Box>
          <Bone type="line" css={{ width: '60%', height: '350' }} />
        </Box>

        <Box>
          <Box css={{ marginBottom: 'tight' }}>
            <Bone type="line" css={{ width: '55%', height: '500' }} />
          </Box>
          <Bone type="line" css={{ width: '100%', marginBottom: 'default' }} />
          <Bone type="line" css={{ width: '30%', height: '350', marginBottom: 'tight' }} />
          <Box css={{ display: 'flex', gap: 'tight', marginBottom: 'default' }}>
            <Bone type="line" css={{ width: '1200', height: '900' }} />
            <Bone type="line" css={{ width: '1200', height: '900' }} />
          </Box>
          <Bone type="line" css={{ width: '95%', marginBottom: 'default' }} />
        </Box>
      </Box>
    </SkeletonContainer>
  );
}
